import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitionHistoryPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.history)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.history)
    }

    return description
  }

  get staticTitle() {
    const staticTitle = this.websiteTerms.META_TITLE_COMPETITION_HISTORY_WINNERS.format({
      COMPETITION_NAME: this.competitionName,
    });

    return staticTitle
  }

  get staticDescription() {
    return this.descriptionFormatTerm(this.websiteTerms.META_DESCRIPTION_COMPETITION_HISTORY_WINNERS)
  }
}